export function formatStatus(status, haveResponse) {
	if (status === 'waiting_answer') {
		if (haveResponse)
			return "En cours";
		else
			return "Non commencé"
	} else if (status === 'draft')
		return "Brouillon"
	else if (status === 'done')
		return "Terminé"

	return status;
}

export function getStateColor(status) {

	return status;
}

export function canUpdateForm(interview, connectedUser) {
	return interview.user.id === connectedUser.id && interview.state === "waiting_answer"
}

export function canUpdateQuestion(question, interview, connectedUser) {
	return canUpdateForm(interview, connectedUser) && !question.readonly;
}
